import http from "../../../../Utils/http";

export function ProfileData() {
    return http.get(`api/pharmacy/profile`);
  }

  export function EditData(data) {
    return http.post(`api/pharmacy/profile`, data);
  }